import CheckoutBranchServices from '@/services/Checkout/branch'
import axios from 'axios'

let branchesRequest = null
let branchesGeneration = 0

export const state = () => ({
  cartGroupStoreBranches: []
  /**
   * {
   *  storeBranchId: '',
   *  storeBranches: []
   * }
  */
})

export const mutations = {
  resetCartGroupStoreBranches (state) {
    if (branchesRequest) {
      branchesRequest.source.cancel()
      branchesRequest.resolve(null)
      branchesRequest = null
      branchesGeneration++
    }
    state.cartGroupStoreBranches = []
  },
  setCartGroupStoreBranches (state, payload) {
    const { storeBranches, cartGroupIds } = payload
    state.cartGroupStoreBranches = storeBranches.map((branch) => {
      const cartGroupId = (cartGroupIds && cartGroupIds[branch.store_branch_id]) || branch.store_branch_id
      const previous = state.cartGroupStoreBranches.find((item) => {
        return item.cartGroupId === cartGroupId
      })
      const selectedBranch = previous && branch.store_branches.find((item) => {
        return item.id === previous.storeBranchId
      })

      return {
        cartGroupId,
        storeBranchId: selectedBranch ? selectedBranch.id : branch.store_branch_id,
        selectedBranch: selectedBranch || {},
        storeBranches: branch.store_branches
      }
    })
  },
  modifyCartGroupStoreBranches (state, payload) {
    const { storeBranchId, fields } = payload

    const cartGroupStoreBranchIdx = state.cartGroupStoreBranches.findIndex((branch) => {
      return branch.cartGroupId === storeBranchId
    })

    if (cartGroupStoreBranchIdx === -1) {
      return
    }

    fields.forEach((field) => {
      const { name, value } = field

      state.cartGroupStoreBranches[cartGroupStoreBranchIdx][name] = value

      if (name === 'selectedBranch') {
        state.cartGroupStoreBranches[cartGroupStoreBranchIdx].storeBranchId = value.id
      }
    })
  }
}

export const actions = {
  getBranchesForCheckout ({ commit }, payload) {
    const { cartGroupIds, ...requestPayload } = payload
    const key = JSON.stringify(payload)
    if (branchesRequest && branchesRequest.key === key) { return branchesRequest.promise }

    if (branchesRequest) {
      branchesRequest.source.cancel()
      branchesRequest.resolve(null)
    }

    const request = {
      key,
      generation: ++branchesGeneration,
      source: axios.CancelToken.source(),
      resolve: null
    }
    request.promise = new Promise((resolve, reject) => {
      request.resolve = resolve
      CheckoutBranchServices.getBranchesForCheckout({
        loggedIn: this.$auth.loggedIn,
        value: this.$auth.loggedIn
          ? this.$auth.getToken(this.$auth.strategy.name)
          : this.$cookies.get('session_id') || ''
      },
      { ...requestPayload, cancelToken: request.source.token })
        .then((response) => {
          if (request.generation === branchesGeneration) {
            commit('setCartGroupStoreBranches', {
              storeBranches: response.data.data.store_branches,
              cartGroupIds
            })
            resolve(response)
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) { return resolve(null) }
          reject(error)
        })
        .finally(() => {
          if (branchesRequest === request) {
            branchesRequest = null
          }
        })
    })
    branchesRequest = request
    return request.promise
  }
}
